// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"e9db6a70","123":"37171bf0","218":"46eef581","226":"ee18b934","320":"f3c593b7","520":"8ae7b261","825":"a283407a","950":"4344b30c"}[chunkId] + ".chunk.js";
};